import * as R from 'remeda';
import { OperationLog } from '@rossum/mdh-api-client';
import {
  getGridDateOperators,
  getGridNumericOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
  GridFilterOperator,
} from '@rossum/ui/x-data-grid-pro';

export type Fields = keyof OperationLog | 'document_name' | 'records';

export const metaColumnDataTypesMap: Partial<Record<Fields, FieldDataType>> = {
  _id: 'string',
  status: 'singleSelect',
  dataset_name: 'string',
  type: 'string',
  document_name: 'string',
  created: 'date',
  updated: 'date',
  message: 'singleSelect',
  records: 'number',
};

const isSelectOperator = (operator: GridFilterOperator) =>
  operator.value === 'isAnyOf' || operator.value === 'notIn'; // codespell:ignore

const filterSingleSelectOperators = (operators: GridFilterOperator[]) =>
  operators.filter(isSelectOperator);

// function for moving "startsWith" operator as a first item and returning sorted array
const sortStringOperators = (operators: GridFilterOperator[]) =>
  R.sortBy(operators, ({ value }) => (value === 'startsWith' ? -1 : 1));

const stringOperators = sortStringOperators(getGridStringOperators());

const numberOperators = getGridNumericOperators();

const dateTimeOperators = getGridDateOperators();

const singleSelectOperators = filterSingleSelectOperators(
  getGridSingleSelectOperators()
);

export const filterOperators = {
  string: stringOperators,
  number: numberOperators,
  date: dateTimeOperators,
  singleSelect: singleSelectOperators,
} as const;

export type FieldDataType = keyof typeof filterOperators;
